import classNames from 'classnames';
import type { Dispatch, SetStateAction, VoidFunctionComponent } from 'react';
import { Icon, icons } from '../../../generic';
import type { SortableColumn, SortType } from '../types';
import css from './VulnerabilitiesTable.module.less';

type VulnerabilitiesTableTableHeaderProps = {
  sortByColumn: SortableColumn;
  setSortByColumn: Dispatch<SetStateAction<SortableColumn>>;
  sortType: SortType;
  setSortType: Dispatch<SetStateAction<SortType>>;
};

const VulnerabilitiesTableTableHeader: VoidFunctionComponent<VulnerabilitiesTableTableHeaderProps> = ({
  sortByColumn,
  setSortByColumn,
  sortType,
  setSortType,
}) => {
  const isSortedBySeverity = sortByColumn === 'cvss';
  const isSortedByVulnerability = sortByColumn === 'title';
  const isSortedByCve = sortByColumn === 'cve';
  const isSortedByFixable = sortByColumn === 'fixable';
  const sortIcon = sortType === 'desc' ? <Icon icon={icons.sortDescending} /> : <Icon icon={icons.sortAscending} />;

  const handleSort = (column: SortableColumn) => {
    if (sortByColumn === column) {
      setSortType((previousSortType) => (previousSortType === 'desc' ? 'asc' : 'desc'));
    } else {
      setSortByColumn(column);
      setSortType('desc');
    }
  };

  return (
    <thead>
      <tr>
        <th
          className={classNames(css.tableHeader, css.severityColumn, { [css.sortedHeader]: isSortedBySeverity })}
          onClick={() => handleSort('cvss')}
        >
          Severity {isSortedBySeverity && sortIcon}
        </th>
        <th className={classNames(css.tableHeader, { [css.sortedHeader]: isSortedByVulnerability })} onClick={() => handleSort('title')}>
          Vulnerability {isSortedByVulnerability && sortIcon}
        </th>
        <th
          className={classNames(css.tableHeader, css.cveColumn, { [css.sortedHeader]: isSortedByCve })}
          onClick={() => handleSort('cve')}
        >
          CVE {isSortedByCve && sortIcon}
        </th>
        <th
          className={classNames(css.tableHeader, css.fixableColumn, { [css.sortedHeader]: isSortedByFixable })}
          onClick={() => handleSort('fixable')}
        >
          Fixable {isSortedByFixable && sortIcon}
        </th>
      </tr>
    </thead>
  );
};

export default VulnerabilitiesTableTableHeader;
